module.exports = __webpack_public_path__ + "static/media/seven.5867720d.jpg";